import config from '../config/config.json';

export const CognitoConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.cognito.userPoolId,
      userPoolClientId: config.cognito.userPoolClientId,
      username: config.cognito.username,
      // region: env.AWS_REGION,
      mandatorySignIn: config.cognito.mandatorySignIn,
      authenticationFlowType: config.cognito.authenticationFlowType,
      signInAliases: config.cognito.signInAliases,
    },
  },
};
